import type { LifecycleEntries } from 'hooks/useLifecycle';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

import { useSawBoxOnboarding } from './useSawBoxOnboarding';

export const useUpdateSawBoxOnboarding = () => {
  const currentValue = useSawBoxOnboarding();
  const { update: updateLifecycle } = useLifecycle();

  return (newValue: LifecycleEntries[LIFECYCLE.sawBoxOnboarding]) => {
    updateLifecycle(LIFECYCLE.sawBoxOnboarding, {
      ...currentValue,
      ...(newValue || {}),
    });
  };
};
